import { useEffect, useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { getCollaboratorDetails } from '../../services/collaborators';
import {
	ICollaboratorDetails,
	IEmployee,
	IQuestionnaires,
} from './CollaboratorDetails.types';

export const useCollaboratorDetails = ({
	campaignId,
	employeeId,
	campaignAnswerId,
}: ICollaboratorDetails) => {
	const [questionnaireSelected, setQuestionnaireSelected] = useState(undefined);
	const [loading, setLoading] = useState<boolean>(true);
	const [hasError, setError] = useState<boolean>(false);
	const [questionnaries, setQuestionnaries] = useState<IQuestionnaires[]>([]);
	const [employee, setEmployee] = useState<IEmployee>({
		name: '',
		position: '',
		branchOffice: '',
		sector: '',
		shift: '',
	});

	const riskStatus = (risk: string) => {
		return risk !== 'Nulo' && risk !== 'Bajo';
	};

	const riskName = (risk: string, categories: any[]) => {
		if (!hasCategory(categories)) return 'Sin respuesta';

		return risk !== 'Nulo' && risk !== 'Bajo'
			? 'Requiere atención'
			: 'No requiere atención';
	};

	const hasCategory = (categories: any[]) => {
		return Boolean(categories.length);
	};

	const fetchCollaboratorDetails = async () => {
		setError(false);
		setLoading(true);

		try {
			const { data } = await getCollaboratorDetails(
				campaignId,
				employeeId,
				campaignAnswerId,
			);
			setEmployee(data.content.employee);
			setQuestionnaries(data.content.questionnaires);
		} catch (error) {
			setError(true);
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'employeeDetails',
			});
		} finally {
			setLoading(false);
		}
	};

	const refereceGuide = (sequence: number) => {
		const reference: { [key: number]: string } = {
			0: 'I',
			1: 'II',
			2: 'III',
		};

		return reference[sequence] || '';
	};

	const resetComponent = () => {
		setQuestionnaireSelected(undefined);
		setQuestionnaries([]);
		setLoading(false);
		setEmployee({
			name: '',
			position: '',
			branchOffice: '',
			sector: '',
			shift: '',
		});
	};

	useEffect(() => {
		fetchCollaboratorDetails();

		return () => resetComponent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		questionnaireSelected,
		loading,
		questionnaries,
		employee,
		hasError,
		refereceGuide,
		hasCategory,
		fetchCollaboratorDetails,
		setEmployee,
		setQuestionnaries,
		setLoading,
		setQuestionnaireSelected,
		riskStatus,
		riskName,
	};
};
